<template>
  <RadioGroupRoot
    v-model="selectedValue"
    class="tw-flex tw-gap-2"
    :class="isVertical ? 'tw-flex-col' : 'tw-flex-row'"
    :default-value="selectedValue"
  >
    <slot />
  </RadioGroupRoot>
</template>
<script setup lang="ts">
import { RadioGroupRoot } from "reka-ui";

export interface Props {
  testId: string;
  id: string;
  isVertical?: boolean;
  disabled?: boolean;
  readonly?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  readonly: false,
  isVertical: true,
});

const selectedValue = defineModel<string>();
</script>
